import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MatTabChangeEvent } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { Defaults } from 'src/app/Utilities/defaults';
import { configuration } from 'src/environments/environment';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';

@Component({
  selector: 'app-checkin-header',
  templateUrl: './checkin-header.component.html',
  styleUrls: ['./checkin-header.component.css']
})

export class CheckinHeaderComponent implements OnInit {
  @Input() widgetposition: number = 0;
  isdisablebtn:boolean=false;

  constructor(private router: Router, private route: ActivatedRoute,private bannerService: PatientBannerService, private crypto: AESAlgorithm,private toastr: ToastrService,
    private schedulerService: SchedularServiceService,) { 
      var url:any=this.router.url;
      if(url.includes("Type")){
       url= url.split('Type=')[1] == 'true' ? this.isdisablebtn=true: this.isdisablebtn=false; 
       sessionStorage.setItem("CheckedinStatus",url)
      }
    }

  ngOnInit() {
  }

  onLinkClick(event: MatTabChangeEvent) {
    event.tab.isActive = true;
    var tabName = event.tab.textLabel;
    sessionStorage.setItem("demoheaderVisibility","false");
    if (tabName == 'Contact Information')
      tabName = 'CheckIncontact';//'contact';
    if (tabName == 'Insurance Information')
      tabName = 'CheckInInsurance';//'Insurance';
    if (tabName == 'Documents')
      tabName = 'CheckIndocuments';//'documents';
    if (tabName == 'Payments') {
      tabName = 'CheckInpayments';//'payments';
      document.getElementById('checkinBtnshowhideBonCon').style.display = "none";
    }else {
      document.getElementById('checkinBtnshowhideBonCon').style.display = "block";
    }

    if (tabName == 'Forms'){
      tabName = 'consentform';
      // this.router.navigateByUrl('/' + event.tab.textLabel+'/'+ Defaults.DocLibraryCheckinForm);
      this.router.navigateByUrl('/ConsentForms/'+ Defaults.DocLibraryCheckinForm);
      return;
   }
    if (tabName == 'Alerts'){
      tabName = 'alerts';
      this.router.navigateByUrl('/CheckIn' + tabName.replace(" ", ""));
    }
    else{
      this.router.navigateByUrl('/'+tabName);
    }
  }

  checkIn() {
//    alert(sessionStorage.getItem("CheckedinStatus"))
// alert(sessionStorage.getItem("NavigationType"))
var navigationType=sessionStorage.getItem("NavigationType");//Forms(CheckedIn)
var checkedInStatus=sessionStorage.getItem("CheckedinStatus");
if(navigationType != null && navigationType != "" && navigationType != undefined &&
checkedInStatus != null && checkedInStatus != "" && checkedInStatus != undefined){
  if(navigationType=="Forms(CheckedIn)"){
    this.toastr.error('Accessing the patient check-in process via this channel is not permitted. Kindly utilize the Appt. Status feature on the Patient Board to initiate patient check-ins');
    return false;
  }
}
  // if(sessionStorage.getItem("NavigationType")
    var Id = sessionStorage.getItem("appId");
    this.schedulerService.UpdatecheckinStatus(Id, "checkin").subscribe(
      results => {
        this.toastr.success(results);
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("patientDob");
        sessionStorage.removeItem("encounterid");
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.router.navigateByUrl('Appointments');
      }, (err: any) => {
        console.log(err);
      });

  }

  closeCheckIn() {
    sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("encounterid");
        sessionStorage.removeItem("NavigationType")
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.router.navigateByUrl('Appointments');
  }

}
